import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AppsIcon from "@mui/icons-material/Apps";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PaidIcon from "@mui/icons-material/Paid";
import HubIcon from "@mui/icons-material/Hub";
import GroupsIcon from "@mui/icons-material/Groups";

// Pure UI catalog: icon/label/color per app key. This file does NOT decide
// which apps a user can see - that's driven entirely by the JWT token's
// userProduct.apps (appStatus + subscription), read in Header/index.js and
// in Pages/Users/add.js + edit.js. Every app the backend can send should
// have an entry here so it always has something to render with.
const appUIConfigs = {
  incident: {
    name: 'incident',
    label: 'Support Centre',
    description: 'Client support & tickets',
    icon: SupportAgentIcon,
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%)',
    shadowColor: 'rgba(59, 130, 246, 0.3)',
  },
  lead: {
    name: 'lead',
    label: 'Lead',
    description: 'Manage your leads',
    icon: LeaderboardIcon,
    gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%)',
    shadowColor: 'rgba(16, 185, 129, 0.3)',
  },
  billing: {
    name: 'billing',
    label: 'Billing',
    description: 'Invoices & payments',
    icon: ReceiptLongIcon,
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(217, 119, 6, 0.05) 100%)',
    shadowColor: 'rgba(245, 158, 11, 0.3)',
  },
  contacts: {
    name: 'contacts',
    label: 'Contacts',
    description: 'Manage your contacts',
    icon: AppsIcon, // You can replace with a more suitable icon if available
    gradient: 'linear-gradient(135deg, #06beb6 0%, #48b1f3 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(6, 190, 182, 0.1) 0%, rgba(72, 177, 243, 0.05) 100%)',
    shadowColor: 'rgba(72, 177, 243, 0.3)',
  },
  recruit: {
    name: 'recruit',
    label: 'Recruit',
    description: 'Hiring & recruitment',
    icon: PersonSearchIcon,
    gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(124, 58, 237, 0.05) 100%)',
    shadowColor: 'rgba(139, 92, 246, 0.3)',
  },
  accounts: {
    name: 'accounts',
    label: 'Accounts',
    description: 'Manage company accounts',
    icon: AccountBalanceIcon,
    gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(20, 184, 166, 0.1) 0%, rgba(13, 148, 136, 0.05) 100%)',
    shadowColor: 'rgba(20, 184, 166, 0.3)',
  },
  payroll: {
    name: 'payroll',
    label: 'Payroll',
    description: 'Employee payroll & salaries',
    icon: PaidIcon,
    gradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.1) 0%, rgba(219, 39, 119, 0.05) 100%)',
    shadowColor: 'rgba(236, 72, 153, 0.3)',
  },
  crm: {
    name: 'crm',
    label: 'CRM',
    description: 'Customer relationship management',
    icon: HubIcon,
    gradient: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(79, 70, 229, 0.05) 100%)',
    shadowColor: 'rgba(99, 102, 241, 0.3)',
  },
  people: {
    name: 'people',
    label: 'People',
    description: 'Manage your team & HR',
    icon: GroupsIcon,
    gradient: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(249, 115, 22, 0.1) 0%, rgba(234, 88, 12, 0.05) 100%)',
    shadowColor: 'rgba(249, 115, 22, 0.3)',
  },
};

export default appUIConfigs;
